export default __webpack_public_path__ + "static/media/thum2.deff9bea.jpg";